// utils/deep.ts
export function isPlainObject(v: any) {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

export function deepClone<T>(v: T): T {
  return isPlainObject(v) ? JSON.parse(JSON.stringify(v)) : v;
}

/** Merge profundo (objetos), arrays y escalares se reemplazan por source */
export function deepMerge<T extends Record<string, any>>(target: T, source: any): T {
  if (!isPlainObject(source)) return source as T;
  const out: any = isPlainObject(target) ? { ...target } : {};
  for (const k of Object.keys(source)) {
    const sv = source[k];
    const tv = out[k];
    if (isPlainObject(sv) && isPlainObject(tv)) out[k] = deepMerge(tv, sv);
    else out[k] = deepClone(sv);
  }
  return out;
}

/** set profundo inmutable: devuelve un nuevo objeto con la ruta aplicada */
export function deepSetImmutable(obj: any, path: string, value: any): Record<string, any> {
  if (!path) return value;

  const segs = path.split('.');
  const [head, ...tail] = segs;
  const curr = obj && typeof obj === 'object' && !Array.isArray(obj) ? obj : {};

  return {
    ...curr,
    [head]: tail.length
      ? deepSetImmutable(curr[head], tail.join('.'), value)
      : value,
  };
}

/**
 * Construye un PATCH que hace merge bajo la clave top-level de la ruta.
 * Ej: path "additional_data.billing.invoice"
 *  -> { additional_data: deepMerge(item.additional_data, { billing:{ invoice:value }}) }
 * Si la ruta es de 1 nivel (ej 'notes'), retorna { notes: value }.
 */
export function buildMergePatch(item: any, fullPath: string, value: any) {
  const segs = fullPath.split('.');
  const top = segs[0];
  const rest = segs.slice(1).join('.');

  if (!rest) {
    // ruta de 1 nivel -> simple asignación
    return { [top]: value };
  }

  const currentTop = isPlainObject(item?.[top]) ? item[top] : {};
  const deltaUnderTop = deepSetImmutable({}, rest, value);
  const mergedTop = deepMerge(currentTop, deltaUnderTop);
  return { [top]: mergedTop };
}
